




























































































import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";
import { User } from "@/models/User";
import ResetPasswordDialog from "@/components/ResetPasswordDialog.vue";
import { validateDni, dniFilter } from "@/filters/DniFilter";
import session from "@/services/SessionService";
import ValidateUserDialog from "./ValidateUserDialog.vue";
import DeleteUserDialog from "./DeleteUserDialog.vue";
import DeleteAccountDialog from "./DeleteAccountDialog.vue";

@Component({
  filters: {
    dni: dniFilter
  },
  components: {
    ResetPasswordDialog,
    ValidateUserDialog,
    DeleteUserDialog,
    DeleteAccountDialog
  }
})
export default class UserActions extends Vue {
  @Prop() user!: Partial<User>;
  @Prop() sessionUser!: Partial<User>;

  loading = false;

  changePasswordClick() {
    this.$router.push({ path: "/password_change" });
  }
}
